import { api } from '../../DefaultService';
import { IHomeAssistantCreateProps, IHomeAssistantUpdateParams } from './types';

const ENDPOINT = '/v1/integrations/home-assistant';

export const createHomeAssistantIntegrationAsync = async (
  data: IHomeAssistantCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateHomeAssistantIntegrationAsync = async ({
  id,
  data,
}: IHomeAssistantUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteHomeAssistantIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getHomeAssistantIntegrationByIdAsync = async (id: number) => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
